export class GPLiteError extends Error {
  readonly code?: string
  constructor(message: string, code?: string) {
    super(message)
    this.name = "GPLiteError"
    if (code) this.code = code
  }
}

export class ConfigError extends GPLiteError {
  constructor(message: string, code?: string) {
    super(message, code)
    this.name = "ConfigError"
  }
}

export class ProblemError extends GPLiteError {
  constructor(message: string, code?: string) {
    super(message, code)
    this.name = "ProblemError"
  }
}

export class EvolutionError extends GPLiteError {
  constructor(message: string, code?: string) {
    super(message, code)
    this.name = "EvolutionError"
  }
}
